import useAnimationScreenStore from "stores/animationScreenStore";

const useAnimationScreen = () => {
    const store = useAnimationScreenStore();

    const show = (id: string) => {
        return store.show(id);
    };
    const stop = (id: string) => {
        return store.stop(id);
    };

    const hide = (id: string) => {
        return store.hide(id);
    };

    return { show, stop, hide, animations: store.animations };
};

export default useAnimationScreen;